import React, { useState } from "react";
import PropTypes from "prop-types";

// UI Material
import { Avatar, Button, Card, Stack, Typography } from "@mui/material";

// Material Icons
import { Add } from "@mui/icons-material";

// Helpers
import { selectProductImage } from "../../Helpers/productSelector";

// Local Components
import AddProductToOrderDrawer from "../drawers/AddProductToOrderDrawer";

export default function ProductCard({ product = {}, cart, setCart }) {
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <>
      <Card raised sx={{ height: "100%" }}>
        <Stack
          sx={{ height: "100%" }}
          spacing={1}
          justifyContent="space-between"
        >
          <Stack direction="row" spacing={1} alignItems="flex-start" sx={{p:2}}>
            <Avatar
              sx={{ height: 115, width: 115 }}
              src={selectProductImage(product.productName)}
              alt={product.productName}
            />

            <Stack sx={{ width: "100%" }}>
              <Typography variant="h6" fontWeight="bold">
                {product.productName}
              </Typography>
              <Typography variant="body2" fontWeight="bold" color="secondary">
                Descripción
              </Typography>
              <Typography variant="body2">{product.details}</Typography>
            </Stack>
          </Stack>

          <Stack sx={{p:2}}>
            <Button
              variant="outlined"
              size="small"
              endIcon={<Add />}
              color="secondary"
              onClick={() => setDrawerOpen(true)}
            >
              AGREGAR PRODUCTO
            </Button>
          </Stack>
        </Stack>
      </Card>

      <AddProductToOrderDrawer
        open={drawerOpen}
        setOpen={setDrawerOpen}
        product={product}
        cart={cart}
        setCart={setCart}
      />
    </>
  );
}

ProductCard.propTypes = {
  product: PropTypes.object.isRequired,
  cart: PropTypes.array.isRequired,
  setCart: PropTypes.func.isRequired,
};
